import React from "react";
import lazyImport from "../../../utils/lazyImport/lazyImport";

// prettier-ignore
const OnDemand = lazyImport(() => import("./OnDemand/OnDemand"));
const Replays = lazyImport(() => import("./Replays/Replays"));
const TvSchedule = lazyImport(() => import("./TvSchedule/TvSchedule"));
const RtvPlaySchedule = lazyImport(
  () => import("./TvSchedule/RtvPlaySchedule")
);
const CatchUp = lazyImport(() => import("./CatchUp/CatchUp"));
const Watch = lazyImport(() => import("./Watch"));
const IndividualReplay = lazyImport(() => import("./IndividualReplay"));
const IndividualOnDemand = lazyImport(() => import("./IndividualOnDemand"));
const FeaturedVideo = lazyImport(() => import("./FeaturedVideo"));
const CombinedOnDemand = lazyImport(() => import("./CombinedOnDemand"));

export default {
  OnDemand,
  Replays,
  TvSchedule,
  RtvPlaySchedule,
  CatchUp,
  Watch,
  IndividualReplay,
  IndividualOnDemand,
  FeaturedVideo,
  CombinedOnDemand,
};
